export enum EstimateBudgetTypesEnum {
  Global = 'Global',
  Time = 'Time',
  Expense = 'Expense',
  InternalFee = 'InternalFee'
}
